import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledIconButton = styled(IconButton)(({ theme, active }) => ({
  [theme.breakpoints.down('sm')]: {
    width: 24,
    height: 24,
    padding: 2,
  },
  [theme.breakpoints.up('sm')]: {
    width: 26,
    height: 26,
    padding: 3,
  },
  [theme.breakpoints.up('md')]: {
    width: 28,
    height: 28,
    padding: 4,
  },
  borderRadius: 3,
  transition: 'all 0.2s ease',
  backgroundColor: active 
    ? theme.palette.primary.main
    : 'transparent',
  color: active 
    ? theme.palette.getContrastText(theme.palette.primary.main)
    : theme.palette.text.primary,
  border: `1px solid ${active ? theme.palette.primary.main : theme.palette.divider}`,
  borderWidth: 0.5,
  '&:hover': {
    backgroundColor: active 
      ? theme.palette.primary.dark
      : theme.palette.action.hover,
    borderColor: active
      ? theme.palette.primary.dark
      : theme.palette.divider,
    color: active
      ? theme.palette.getContrastText(theme.palette.primary.dark)
      : theme.palette.text.primary,
  },
  '&.Mui-disabled': {
    color: theme.palette.action.disabled,
    borderColor: theme.palette.divider,
    opacity: theme.palette.action.disabledOpacity,
  },
}));

const ToolbarButton = ({ 
  icon, 
  tooltip, 
  onClick, 
  active = false, 
  disabled = false,
  size = 'medium',
  ...props 
}) => {
  const button = (
    <StyledIconButton
      onClick={onClick}
      active={active}
      disabled={disabled}
      size="small"
      {...props}
    >
      {React.cloneElement(icon, { 
        fontSize: size === 'small' ? 'small' : 'medium' 
      })}
    </StyledIconButton>
  );

  if (!tooltip) {
    return button;
  }

  return (
    <Tooltip title={tooltip} arrow>
      {button}
    </Tooltip>
  );
};

export const ToolbarDivider = styled(Box)(({ theme }) => ({
  width: 1,
  height: 16,
  backgroundColor: theme.palette.divider,
  margin: 0, // No margin - spacing controlled by parent
  opacity: 0.3,
  flexShrink: 0,
}));

export const ToolbarGroup = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 0, // No gap - spacing controlled by parent
  flexShrink: 0,
  '& > *': {
    flexShrink: 0,
  },
}));

export default ToolbarButton;